import store from '../..';
import { GET_IMAGES } from '../../../../constants/apiRoutes';
import { ApiError } from '../../../../types/Content';
import { httpClient } from '../../../../utils/httpClient';
import Logger from '../../../../utils/logger';
import {
  ApiPayloadUsed,
  knowledgeCenterStateSegment,
  Image,
  Pagination,
} from '../../stateSegments/brandsInformationStateSegment';

export interface ImagesResponse {
  success: boolean;
  data?: {
    images: Image[] | [];
    pagination: Pagination;
  };
}

export const getImages = async (
  apiPayload: ApiPayloadUsed
): Promise<ImagesResponse> => {
  const {
    brand: brandName,
    country: countryName,
    indication: indicationName,
    nextPageToken,
    targetAudience,
    page,
    pageSize,
    aemAssetIntegrationEnabled,
  } = apiPayload;

  try {
    // Build params conditionally
    // Build params for GET_IMAGES
    const params: {
      countryName: string;
      brandName: string;
      indicationName?: string;
      nextPageToken?: string | null;
      audienceNames?: string[];
      page?: number;
      pageSize?: number;
    } = {
      countryName,
      brandName,
      indicationName: indicationName || 'ANY',
      audienceNames: targetAudience?.filter(
        (audience): audience is string => audience !== undefined
      ),
    };
    if (aemAssetIntegrationEnabled) {
      // When AEM asset integration is enabled, send page and pageSize but not nextPageToken
      if (typeof page !== 'undefined') params.page = page;
      if (typeof pageSize !== 'undefined') params.pageSize = pageSize;
    } else {
      // When AEM asset integration is disabled, send all pagination parameters
      if (typeof nextPageToken !== 'undefined')
        params.nextPageToken = nextPageToken;
    }
    const response = await httpClient.get<ImagesResponse>(GET_IMAGES(params));
    const { data, success } = response as ImagesResponse;

    if (success && data) {
      return {
        success: true,
        data,
      };
    }
    return {
      success: false,
    };
  } catch (error) {
    const postError = error as ApiError;
    Logger.error(new Error(postError.message));
    return {
      success: false,
    };
  }
};

export const fetchImages = async (payload: ApiPayloadUsed) => {
  store.set(knowledgeCenterStateSegment, prev => {
    return {
      ...prev,
      images: {
        ...prev.images,
        isLoading: true,
      },
    };
  });

  const { success, data } = await getImages({
    ...payload,
  });

  if (success && data) {
    store.set(knowledgeCenterStateSegment, prev => {
      return {
        ...prev,
        images: {
          ...prev.images,
          data: {
            ...prev.images.data,
            images: data.images,
            imagesPagination: data.pagination,
          },
          isLoading: false,
        },
      };
    });
  } else {
    store.set(knowledgeCenterStateSegment, prev => {
      return {
        ...prev,
        images: {
          ...prev.images,
          isLoading: false,
          errorMessage: 'There has been an error in fetching images',
        },
      };
    });
  }
  return success;
};
